'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DueDate$() {
  this.aJr = null;
  this.aJs = false;
  this.aJt = null;
  this.aJu = false;
  this.aJl = null;
  this.aJm = false;
  this.aJn = null;
  this.aJo = false;
  this.aJp = null;
  this.aJq = false;
  this.aJv = null;
  this.aJw = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DueDate$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DueDate$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DueDate$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DueDate$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$DueDate$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$DueDate$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$DueDate$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$DueDate$.prototype = $p;
$p.aA = (function() {
  if ((!this.aJs)) {
    this.aJr = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate$Newtype$$anon$2(this);
    this.aJs = true;
  }
  return this.aJr;
});
$p.t1 = (function() {
  if ((!this.aJu)) {
    this.aJt = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate$Newtype$$anon$4(this);
    this.aJu = true;
  }
  return this.aJt;
});
$p.bW = (function() {
  if ((!this.aJm)) {
    this.aJl = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aJm = true;
  }
  return this.aJl;
});
$p.jh = (function() {
  if ((!this.aJo)) {
    this.aJn = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lalleycats_Empty$$anon$1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => {
      var e$proxy3 = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$DueDate$().iu(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_data_FrameworkDate$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_FrameworkPlatform$().ag0())));
      matchResult24: {
        var $x_1;
        if ((e$proxy3 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
          throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalStateException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalStateException(), (("Expected Right, got Left(" + e$proxy3.bj) + ")"));
        }
        if ((e$proxy3 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
          var ev$3 = e$proxy3.aI;
          var $x_1 = ((ev$3 === null) ? null : ev$3.cs);
          break matchResult24;
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(e$proxy3);
      }
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate($x_1);
    })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lalleycats_Empty$());
    this.aJo = true;
  }
  return this.aJn;
});
$p.afb = (function() {
  if ((!this.aJq)) {
    this.aJp = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Due Date";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aJq = true;
  }
  return this.aJp;
});
$p.aY = (function() {
  if ((!this.aJw)) {
    this.aJv = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().Cc;
    this.aJw = true;
  }
  return this.aJv;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$DueDate$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DueDate$, "app.data.data_point_types$package$DueDate$", ({
  FJ: 1,
  B: 1,
  C: 1,
  f0: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$DueDate$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$DueDate$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$DueDate$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$DueDate$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$DueDate$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$DueDate$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DueDate$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$DueDate$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$DueDate$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$DueDate$ };
//# sourceMappingURL=app.data.data_point_types$package$-Due-Date$.js.map
